import { useEffect } from 'react';
import { useBulkChangePermissionService } from '../../services/bulk-change-permission/index.tsx';
import { useBulkSelectionStore } from '../bulk-selection/bulk-selection-store/index.tsx';

export const useBulkChangePermission: () => boolean | undefined = () => {
	const [, { setBulkChangePermission }] = useBulkSelectionStore();

	const bulkChangePermission = useBulkChangePermissionService();

	useEffect(() => {
		bulkChangePermission !== null &&
			bulkChangePermission !== undefined &&
			setBulkChangePermission({ bulkChangePermission });
	}, [bulkChangePermission, setBulkChangePermission]);

	return bulkChangePermission;
};
